/**
 * UI-84: which board (if any) the user just left.
 *
 * The discard used to hang off BoardCanvas's unmount, which was wrong: the
 * canvas unmounts for reasons that are not a departure — React.StrictMode's
 * effect replay, and the auth/loading gates above it swapping the tree out and
 * back. A board created and then remounted for longer than the grace period
 * was deleted while the user was still sitting on it, which is what "it
 * appears for a few seconds and then vanishes" was.
 *
 * A route change is the honest signal, and it is a pure string comparison.
 */
const BOARD_PATH = /^\/board\/([^/?#]+)/

export function boardLeft(from: string | null, to: string): string | null {
  if (!from || from === to) return null
  const wasOn = BOARD_PATH.exec(from)
  if (!wasOn) return null
  const boardId = wasOn[1]
  // Still the same board — a sub-route or a query/hash change, not a departure.
  const nowOn = BOARD_PATH.exec(to)
  if (nowOn && nowOn[1] === boardId) return null
  return boardId
}
